import React, { Component } from 'react'
import axios from 'axios'

class Phoenix extends Component {
  state = {
    messages: [],
    phoenix: {
      text: {
        text: ['']
      }
    },
    text: 'vai'
  }

  componentWillMount() {
    this.df_text_query(this.props.steps.search.value)
  }

  async df_text_query(text) {
    let says = {
      speaks: 'me',
      msg: {
        text: {
          text: text
        }
      }
    }
    this.setState({ messages: [...this.state.messages, says] })

    let url = 'https://inchatbot.herokuapp.com/api/df_text_query'
    if (process.env.NODE_ENV === 'development') {
      url = `/api/df_text_query`
    }

    const res = await axios.post(url, { text })

    for (let msg of res.data.fulfillmentMessages) {
      says = {
        speaks: 'bot',
        msg: msg
      }
      //this.setState({ messages: [...this.state.messages, says] })
      this.setState({ phoenix: msg })
    }
  }

  async df_event_query(event) {
    let url = 'https://inchatbot.herokuapp.com/api/df_event_query'
    if (process.env.NODE_ENV === 'development') {
      url = `/api/df_event_query`
    }
    const res = await axios.post(url, { event })

    for (let msg of res.data.fulfillmentMessages) {
      let says = {
        speaks: 'me',
        msg: msg
      }
      this.setState({ messages: [...this.state.messages, says] })
    }
  }

  render() {
    return <div>{this.state.phoenix.text.text[0]}</div>
  }
}

export default Phoenix
